export default {
    'ETH_UAX': '#2965FF',
    'ETH_ONE': '#35D4D3',
    'TRX_USDT': '#31D182',
    'TRX_BTT': '#D73A64',
    'XVG': '#00CBFF',
    'DOGE': '#CEB55C',
    'ETH_SOUL': '#A1B8CE',
    'TRX': '#E51A31',
    'LTC': '#60BBF5',
    'ETH': '#1EB3E4',
    'ETH_ROPSTEN': '#68268C',
    'BTC': '#F79E1B',
    'BTC_TEST': '#F79E1B',
    'BTC_SEGWIT': '#F79E1B',
    'BTC_SEGWIT_COMPATIBLE': '#F79E1B',
    'BCH': '#F79E1B',
    'BTG': '#132365',
    'USDT': '#31D182',
    'ETH_TRUE_USD': '#5BB6ED',
    'ETH_USDT': '#31D182',
    'ETH_BNB': '#F59E6C',
    'ETH_USDC': '#2A7FDB',
    'BSV': '#C8102E',
    'ETH_PAX': '#02D193',
    'ETH_DAI': '#FF6F45',
    'ETH_DAIM': '#F4B731',
    'ETH_OKB': '#3075EE',
    'ETH_BNT': '#000D2B',
    'ETH_KNC': '#31CB9E',
    'ETH_MKR': '#1AAB9B',
    'XRP': '#1B1818',
    'XMR': '#F26822',
    'XLM': '#181818',
    'FIO': '#4C5FAB',
    'ETH_BAT': '#9E1F63',
    'ETH_UNI': '#FF007A',
    'ETH_ENJ': '#7866D5',
    'ETH_1INCH': '#1B314F',
    'ETH_AAVE': '#2EBAC6',
    'ETH_BADGER': '#C5C5C5',
    'ETH_BTC': '#282138',
    'ETH_CHZ': '#CD0124',
    'ETH_CRO': '#103F68',
    'ETH_CRV': '#C5C5C5', //change
    'ETH_GRT': '#6747ED',
    'ETH_HUOBI': '#357CE1',
    'ETH_MATIC': '#8247E5',
    'ETH_OMG': '#141414',
    'ETH_RSR': '#161616',
    'ETH_SNX': '#00D1FF',
    'ETH_SUSHI': '#FA52A0',
    'ETH_YFI': '#006AE3',
    'ETH_ZRX': '#231815',
    'ETH_SXP': '#FF5331',
    'ETH_LINK': '#375BD2',
    'ETH_BAL': '#303030',
    'ETH_COMP': '#00D395',
    'ETH_BUSD': '#F0B90B',
    'ETC': '#3AB83A',
    'ETH_SHIB': '#F6A31D',
    'BNB_SMART': '#F3B80C',
    'BNB_SMART_ADA': '#0033AD',
    'TON': '#47A9F1',

    'UAH': '#1B3F9A',
    'RUB': '#495951',
    'USD': '#0B6809',
    'KZT': '#8F0906',
    'EUR': '#7B231D',
    'GBP': '#4B338D',
    'TRY': '#9A4C2E',
    "AUD": "#E3BB4D",
    "BGN": "#BF7FA4",
    "BRL": "#6EC074",
    "CAD": "#D10026",
    "CHF": "#E75E53",
    "CNY": "#C41F29",
    "COP": "#E99E6A",
	"CZK": "#5BA4EC",
	"DKK": "#C88930",
	"DOP": "#39C9CA",
	"EGP": "#B982A5",
	"HKD": "#067B60",
	"HRK": "#BDB65D",
	"IDR": "#588EE2",
	"ILS": "#E3B741",
	"JOD": "#0191C8",
	"JPY": "#897AC0",
	"KES": "#DF8F73",
	"KRW": "#DFBB57",
	"KWD": "#4BB561",
	"LKR": "#D3B946",
	"MAD": "#9EC949",
	"MXN": "#DC9FC1",
	"MYR": "#CF8A2D",
	"NGN": "#AB343F",
	"NOK": "#E3911B",
	"NZD": "#403E9C",
	"OMR": "#57B8A8",
	"PEN": "#E6AD73",
	"PKR": "#6E739F",
	"PLN": "#E2CC75",
	"RON": "#D8C925",
	"SEK": "#C16B35",
	"SGD": "#88D670",
	"THB": "#64C7B8",
	"TWD": "#9B648F",
	"VND": "#CC6CA4",
	"ZAR": "#468CD5",

    'DEFAULT': '#000'
}
